import {
  getCurrentToken,
  getRegion,
  getEnv,
} from '@adsk/acs-sc-web-platform-api';
import {
  DocsClass,
  DOCS_PRODUCTS,
  cancelAll,
  cancelRequests,
  SortingUtil,
} from '@adsk/docs-js-sdk';

class Service {
  constructor() {
    this.instance = null;
  }

  get sdk() {
    if (!this.instance) {
      this.instance = new DocsClass({
        region: getRegion(),
        env: getEnv(),
        getToken: getCurrentToken,
        buildId: 'file_packages_picker',
        product: DOCS_PRODUCTS.ACC,
      });
    }

    return this.instance;
  }

  getService(key) {
    return this.sdk[key];
  }
}

const instance = new Service();
const services = {
  PackagesList: instance.getService('PackagesList'),
  Projects: instance.getService('Projects'),
};

export { services as default, cancelAll, cancelRequests, SortingUtil };
